export enum UserFeedbackType {
    SUMMARIZATION = 'summarization',
}

export interface SummarizationFeedback {
    type: UserFeedbackType.SUMMARIZATION;
    summarizationId?: string;
    rating?: string;
}

export type UserFeedback = SummarizationFeedback;

export type UserFeedbackState = Maybe<UserFeedback> | null;

export interface UserFeedbackProps<T extends UserFeedback> {
    feedback: T;
}
